<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="nonindent1">It was a blonde. A blonde to make a bishop kick a hole in a stained-glass window.</p>
<p class="center1">—<span class="small">RAYMOND CHANDLER</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi.vue?2a860912